import { CurrenciesService } from "booking_app/services/currencies.service";
import { GlobalStateService } from "booking_app/services/global-state.service";
import { PayWithPointsCashService } from "booking_app/services/pay-with-points-cash.service";
import { HotelItem } from "booking_app/types";

declare var angular : any;

export class PriceBreakdownModal {
  static $inject = [
    "$rootScope",
    "$scope",
    "$modalInstance",
    "$filter",
    "CurrenciesService",
    "GlobalStateService",
    "PayWithPointsCashService",
    "data",
    "type",
    "selectAction",
  ];

  constructor(
    private $rootScope: any,
    private $scope: any,
    private $modalInstance: any,
    private $filter: any,
    private currenciesService: CurrenciesService,
    private globalStateService: GlobalStateService,
    private payWithPointsCashService: PayWithPointsCashService,
    public data: any,
    public type: "hotel" | "booking",
    public selectAction: () => void,
  ) {
    this.$scope.close = () => {
      this.$modalInstance.dismiss("close");
    };
    if (this.type === "hotel") {
      this.prepareHotelData();
    } else {
      this.prepareBookingData();
    }
    this.$scope.zeroFullCashPayment = () => {
      return this.$scope.cash_payment <= 0 && this.$scope.points_payment === 0;
    }
  }

  private prepareHotelData(): void {
    this.$scope.duration = this.$rootScope.duration;
    this.$scope.roomCount = this.$rootScope.roomCount;
    this.$scope.points_payment = this.data.points_payment;
    this.$scope.cash_payment = this.data.cash_payment || 0;
    this.$scope.currency = this.$rootScope.selectedCurrency.code;
    this.calculatePriceBreakdown(this.data);
    this.$scope.base_rate = this.formatValue(this.data.baseRate);
    this.$scope.total_taxes_and_fees = this.formatValue(this.data.includedTaxesAndFeesTotal);
    this.$scope.additional_charges = this.data.excluded_taxes_and_fees_total;
    this.$scope.additional_charges_currency = this.data.excluded_taxes_and_fees_currency;
    if (this.selectAction) {
      this.$scope.toNextPage = this.selectAction;
    }
  }

  private prepareBookingData(): void {
    this.$scope.duration = this.data.number_of_nights;
    this.$scope.roomCount = this.data.numOfRooms;
    this.$scope.points_payment = this.data.paid_in_points || 0;
    this.$scope.cash_payment = this.data.converted_amount || 0;
    this.$scope.currency = this.data.currency;
    this.calculatePriceBreakdown(this.data.price_breakdown_metadata);
    this.$scope.base_rate = this.formatValue(this.data.price_breakdown_metadata.baseRate);
    this.$scope.total_taxes_and_fees = this.formatValue(this.data.price_breakdown_metadata.includedTaxesAndFeesTotal);
    this.$scope.additional_charges = this.data.price_breakdown_metadata.excluded_taxes_and_fees_total;
    this.$scope.additional_charges_currency = this.data.price_breakdown_metadata.excluded_taxes_and_fees?.[0]?.currency;
  }

  private calculatePriceBreakdown(data: HotelItem): void {
    // Use the same service used by checkout page
    this.payWithPointsCashService.calculateAdjustedFeeBreakdown(data);
  }

  private formatValue(value): string {
    if (this.$rootScope.selectedCurrency.decimalPlace === 0) {
      return this.$filter("numberFmt")(Math.ceil(value), this.$rootScope.selectedLocale, 0);
    }
    return this.$filter("numberFmt")(value, this.$rootScope.selectedLocale, 2);
  }
}

angular.module("BookingApp").controller("PriceBreakdownModal", PriceBreakdownModal);
